import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import Login from './pages/Login';
import AuthProvider from './contexts/AuthProvider';
import Dashboard from './pages/Dashboard';
import PrivateRoute from './router/PrivateRoute';
import AppLayout from "./components/AppLayout";
import SessionsPage from "./pages/SessionsPage";
import DatabasePage from "./pages/DatabasePage";

// <Navbar />

function App() {
  return (
    <Router>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route element={<PrivateRoute />}>
            <Route element={<AppLayout />}>
              <Route path="/" element={<Dashboard />} />
              <Route path="sessions" element={<SessionsPage />} />
              <Route path="database" element={<DatabasePage />} />
            </Route>
          </Route>
        </Routes>
      </AuthProvider>
    </Router>
  );
}

export default App;
